var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _mask, _g, _mask2, _g2, _mask3, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFixelLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 33,
    viewBox: "0 0 104 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.62793 5.82463H6.4367V0.00109863H0.62793V5.82463Z",
    fill: "#F2BE41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40625 5.82365H13.2223V0.00012207H7.40625V5.82365Z",
    fill: "#F2BE41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1924 5.82365H20.0084V0.00012207H14.1924V5.82365Z",
    fill: "#F2BE41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.628906 12.6177H6.43767V6.79419H0.628906V12.6177Z",
    fill: "#F2BE41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.628906 19.4119H6.43767V13.5884H0.628906V19.4119Z",
    fill: "#F2BE41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40625 19.4119H13.2223V13.5884H7.40625V19.4119Z",
    fill: "#F2BE41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1924 19.4119H20.0084V13.5884H14.1924V19.4119Z",
    fill: "#F2BE41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.628906 26.206H6.43767V20.3824H0.628906V26.206Z",
    fill: "#F2BE41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.628906 33H6.43767V27.1765H0.628906V33Z",
    fill: "#F2BE41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.916 33.0001H28.7321V0.00012207H22.916V33.0001Z",
    fill: "#575E68"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 0,
    width: 21,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0762 0.00012207V5.82365H67.5055V13.5884H81.0762V19.4119H67.5055V27.1766H81.0762V33.0001H61.6895V0.00012207H81.0762Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6826 33.0006H81.0791V-0.00427246H61.6826V33.0006Z",
    fill: "#575E68"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 0,
    width: 21,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8004 0.00012207V27.1766H103.371V33.0001H83.9844V0.00012207H89.8004Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9727 33.0005H103.384V-0.00439453H83.9727V33.0005Z",
    fill: "#575E68"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 0,
    width: 29,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3136 0.0140838C39.5268 0.0159036 39.8336 0.116117 39.9374 0.288032C41.7789 3.34417 43.5959 6.41851 45.4596 9.55909C45.8648 8.89387 46.2637 8.24079 46.6609 7.5871C48.1202 5.18708 49.5736 2.78281 51.0483 0.394676C51.1643 0.206988 51.4271 0.0217271 51.6233 0.0193007C53.9576 -0.00654123 56.2921 0.00219406 58.6266 0.00377126C58.6785 0.00377126 58.7299 0.0250029 58.8766 0.0575176C58.742 0.292279 58.6308 0.497315 58.5104 0.695437C55.535 5.59448 52.5638 10.4964 49.573 15.3842C49.3163 15.804 49.3404 16.0702 49.6175 16.4508C53.2211 21.3943 56.3212 26.7074 59.0653 32.2792C59.1573 32.4663 59.2446 32.6565 59.3872 32.9572C59.1361 32.9719 58.9846 32.9885 58.8329 32.9885C56.5335 32.9897 54.2344 32.977 51.9353 33.0001C51.523 33.004 51.3057 32.861 51.1162 32.4566C49.9125 29.8901 48.7493 27.2927 47.1478 24.9884C46.5707 24.1583 45.8953 23.4117 45.2133 22.5629C44.8949 22.976 44.6383 23.2923 44.3979 23.623C42.3576 26.4331 40.4981 29.3747 39.0208 32.5994C38.9356 32.7856 38.6552 32.9703 38.464 32.9725C36.1649 32.9994 33.8658 32.9919 31.5664 32.9919C31.4988 32.9919 31.4313 32.9731 31.2764 32.9499C31.3692 32.7254 31.4351 32.5384 31.5214 32.3634C34.1234 27.0761 37.3759 22.2726 40.5884 17.4382C41.5493 15.9924 41.5534 16.5904 40.6626 15.089C37.8026 10.2692 34.9182 5.46709 32.0441 0.658069C31.9392 0.482514 31.8409 0.302348 31.7037 0.0617639C31.8906 0.036286 32.0207 0.00316465 32.1507 0.00280067C34.5382 0.000110656 36.926 -0.005328 39.3136 0.0140838Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2646 33.0003H59.3997V-0.0045166H31.2646V33.0003Z",
    fill: "#575E68"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixelLogo);
export default __webpack_public_path__ + "static/media/FixelLogo.716f6d5c.svg";
export { ForwardRef as ReactComponent };